import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent,
      ),
  },
  {
    path: 'landing',
    loadComponent: () =>
      import('./landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent,
      ),
  },
  {
    path: 'tiket',
    loadComponent: () =>
      import('./marketing-page/ticket-page/ticket-page.component').then(
        (m) => m.TicketPageComponent,
      ),
  },
  {
    path: 'beli-tiket',
    loadComponent: () =>
      import('./marketing-page/ticket-page/ticket-page.component').then(
        (m) => m.TicketPageComponent,
      ),
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'auth/login',
    loadComponent: () =>
      import('./login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'masuk',
    loadComponent: () =>
      import('./login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'logistik',
    loadComponent: () =>
      import('./logistik-page/logistik-page.component').then(
        (m) => m.LogistikPageComponent,
      ),
  },
  {
    path: 'logistik/dashboard',
    loadComponent: () =>
      import('./logistik-page/logistik-page.component').then(
        (m) => m.LogistikPageComponent,
      ),
  },
  {
    path: 'logistik/aktivasi',
    loadComponent: () =>
      import('./logistik-page/logistik-page.component').then(
        (m) => m.LogistikPageComponent,
      ),
  },
  {
    path: 'logistik/distribusi',
    loadComponent: () =>
      import('./logistik-page/logistik-page.component').then(
        (m) => m.LogistikPageComponent,
      ),
  },
  {
    path: 'marketing',
    loadComponent: () =>
      import('./marketing-page/marketing-page.component').then(
        (m) => m.MarketingPageComponent,
      ),
  },
  {
    path: 'marketing/cetak',
    loadComponent: () =>
      import('./marketing-page/marketing-page.component').then(
        (m) => m.MarketingPageComponent,
      ),
  },
  {
    path: 'marketing/dashboard',
    loadComponent: () =>
      import('./marketing-page/marketing-page.component').then(
        (m) => m.MarketingPageComponent,
      ),
  },
  {
    path: 'marketing/tiket',
    loadComponent: () =>
      import('./marketing-page/marketing-page.component').then(
        (m) => m.MarketingPageComponent,
      ),
  },
  {
    path: 'cetak-ticket',
    loadComponent: () =>
      import('./cetak-ticket-page/cetak-ticket-page.component').then(
        (m) => m.CetakTicketPageComponent,
      ),
  },
  {
    path: 'undangan/cetak-ticket',
    loadComponent: () =>
      import('./cetak-ticket-page/cetak-ticket-page.component').then(
        (m) => m.CetakTicketPageComponent,
      ),
  },
  {
    path: 'marketing/cetak-ticket',
    loadComponent: () =>
      import('./cetak-ticket-page/cetak-ticket-page.component').then(
        (m) => m.CetakTicketPageComponent,
      ),
  },
  {
    path: 'scan-ticket',
    loadComponent: () =>
      import('./aktivasi-ticket-page/aktivasi-ticket-page.component').then(
        (m) => m.AktivasiTicketPageComponent,
      ),
  },
  {
    path: 'aktivasi-ticket',
    loadComponent: () =>
      import('./aktivasi-ticket-page/aktivasi-ticket-page.component').then(
        (m) => m.AktivasiTicketPageComponent,
      ),
  },
  {
    path: 'checkin-ticket',
    loadComponent: () =>
      import('./checkin-ticket-page/checkin-ticket-page.component').then(
        (m) => m.CheckinTicketPageComponent,
      ),
  },
  {
    path: 'loket/aktivasi-ticket',
    loadComponent: () =>
      import('./aktivasi-ticket-page/aktivasi-ticket-page.component').then(
        (m) => m.AktivasiTicketPageComponent,
      ),
  },
  {
    path: 'loket',
    loadComponent: () =>
      import('./loket-page/loket-page.component').then(
        (m) => m.LoketPageComponent,
      ),
  },
  {
    path: 'loket/order',
    loadComponent: () =>
      import('./loket-page/loket-page.component').then(
        (m) => m.LoketPageComponent,
      ),
  },
  {
    path: 'loket/dashboard',
    loadComponent: () =>
      import('./loket-page/loket-page.component').then(
        (m) => m.LoketPageComponent,
      ),
  },
  {
    path: 'order-tiket',
    loadComponent: () =>
      import('./loket-page/loket-page.component').then(
        (m) => m.LoketPageComponent,
      ),
  },
  {
    path: 'management',
    loadComponent: () =>
      import('./management-page/management-page.component').then(
        (m) => m.ManagementPageComponent,
      ),
  },
  {
    path: 'management/dashboard',
    loadComponent: () =>
      import('./management-page/management-page.component').then(
        (m) => m.ManagementPageComponent,
      ),
  },
  {
    path: 'device-tab',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
  {
    path: 'device-tab/:id',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
  {
    path: 'device-tab/:id/:tab',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
  {
    path: 'device-web',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
  {
    path: 'device-web/:id',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
  {
    path: 'device-web/:id/:tab',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
  {
    path: 'kiosk',
    loadComponent: () =>
      import('./device-tab/device-tab.component').then(
        (m) => m.DeviceTabComponent,
      ),
  },
];


